import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Loader, EmptyState } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import * as Icons from "lucide-react";
import { toast } from "sonner";

export default function Announcements() {
  const qc = useQueryClient();
  const [form, setForm] = useState({ title: "Announcement", message: "", audience: "all" });
  const { data, isLoading } = useQuery({ queryKey: ["announcements"], queryFn: async () => (await api.get("/announcements")).data });

  const send = async () => {
    if (!form.message) return toast.error("Write a message");
    await api.post("/announcements", form);
    toast.success("Announcement sent! 📢"); setForm({ title: "Announcement", message: "", audience: "all" });
    qc.invalidateQueries({ queryKey: ["announcements"] });
  };

  if (isLoading) return <Loader />;

  return (
    <div className="space-y-5 max-w-2xl" data-testid="announcements-page">
      <h2 className="font-head text-3xl text-csh-blue">Announcements 📢</h2>
      <div className="rounded-3xl bg-white p-6 shadow-sm border border-black/5 space-y-3">
        <Input placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="rounded-xl border-2 py-6" data-testid="ann-title" />
        <Textarea placeholder="Your message to students..." value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="rounded-xl border-2" rows={4} data-testid="ann-message" />
        <Select value={form.audience} onValueChange={(v) => setForm({ ...form, audience: v })}>
          <SelectTrigger className="rounded-xl border-2 py-6"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All Students</SelectItem></SelectContent>
        </Select>
        <Button onClick={send} className="w-full rounded-full gradient-orange py-6 font-bold text-white" data-testid="send-ann-btn"><Icons.Send size={16} /> Send Announcement</Button>
      </div>
      <h3 className="font-head text-xl text-csh-blue">Sent</h3>
      {(!data || data.length === 0) ? <EmptyState icon="Megaphone" title="No announcements yet" /> : (
        <div className="space-y-2">
          {data.map((a) => (
            <div key={a.id} className="rounded-2xl bg-white px-4 py-3 shadow-sm border border-black/5">
              <div className="font-bold text-csh-blue">{a.title}</div>
              <div className="text-sm text-muted-foreground">{a.message}</div>
              <div className="text-[10px] text-muted-foreground mt-1">by {a.sender} · {a.created_at?.slice(0, 10)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
